var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label-width":"0"}},[_c('el-autocomplete',{staticClass:"width-full",attrs:{"size":"mini","fetch-suggestions":_vm.querySearch},model:{value:(_vm.data.contentFormat),callback:function ($$v) {_vm.$set(_vm.data, "contentFormat", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"data.contentFormat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }